import * as toastr from 'toastr';
import {ACTION_TYPES, createAction} from "../actions";
import {call, put, takeEvery} from 'redux-saga/effects'
import {Feature} from "geojson";
import {IGeometryNode} from "../../types";
import {getGeomStringForFeature} from "../../utils/getGeomStringForFeature";
import {createGeometry} from "../../http/createGeometry";
import {getGeoType} from "../../utils/getGeoType";


export function* createEntityGeometrySaga () {
    yield takeEvery(ACTION_TYPES.CREATE_ENTITY_GEOMETRY, _createGeometry);
}

function* _createGeometry (action: any) {
    const payload: {geo_type: string, type: string, fullUid: string, feature: Feature, entity: any} = action.payload;
    try {
        const {type, fullUid, feature, entity} = payload;
        const geoType = getGeoType(feature);
        const theGeom = getGeomStringForFeature(feature);
        const patch: IGeometryNode = {
            // theGeom
            fullUid,
            geoType,
            type,
            theGeom
        };
        yield call(createGeometry, patch);
        if (entity) toastr.success(`Created new entity ${entity.name}`);
        yield put(createAction(ACTION_TYPES.CREATE_ENTITY_GEOMETRY_SUCCESS, {
            fullUid, type, feature, entity
        }));
    } catch (error) {
        toastr.error('Error creating entity - Please try again');
        yield put(createAction(ACTION_TYPES.CREATE_ENTITY_GEOMETRY_ERROR, {error}));
    }
}
